var _defs, _rect, _circle, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4b942"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 64,
    fill: "url(#g)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 104,
    r: 44,
    fill: "rgba(255,255,255,0.85)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 222c18-42 50-62 76-62s58 20 76 62",
    fill: "rgba(255,255,255,0.85)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 144,
    textAnchor: "middle",
    fontFamily: "ui-sans-serif, system-ui",
    fontWeight: 900,
    fontSize: 44,
    fill: "rgba(14,26,20,0.55)"
  }, "NR")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar-2.d1b078e18e8eb2bd9fdae52f8a33e9dc.svg";
export { ForwardRef as ReactComponent };